import React from 'react';
import type { StepperProps, StepStatus } from './stepper-types';
import styles from "./stepper.module.scss";

function getStatus(index: number, currentStep: number): StepStatus {
  if (index < currentStep) return 'completed';
  if (index === currentStep) return 'active';
  return 'upcoming';
}

const Stepper = ({ steps, currentStep, className }: StepperProps) => {
  return (
    <ol className={[styles.stepper, className].filter(Boolean).join(' ')}>
      {steps.map((step, index) => {
        const status = getStatus(index, currentStep);
        const isLast = index === steps.length - 1;
        // The connector after this step is "filled" once we've reached or passed it,
        // including the connector leading out of the current step.
        const connectorFilled = index <= currentStep;

        return ( 
          <li key={step.id} className={styles.step} aria-current={status === 'active' ? 'step' : undefined}>
            <div className={styles.indicatorRow}>
              <span className={`${styles.circle} ${styles[status]}`}>{index + 1}</span>

              {!isLast && (
                <span
                  className={`${styles.connector} ${connectorFilled ? styles.connectorFilled : ''}`}
                  aria-hidden="true"
                />
              )}
            </div>

            <span className={`${styles.label} ${styles[`label-${status}`]}`}>{step.label}</span>
          </li>
        );
      })}
    </ol>
  );
};

export default Stepper;